/**
 * Pending Members Layout
 */

import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function PendingMembersLayout() {
  const colors = useThemeColors();
  const router = useRouter();
  const navigation = useNavigation();

  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      router.replace("/(super-admin)");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: "#DC2626",
        headerTitleStyle: { color: colors.text },
        headerShadowVisible: false,
        contentStyle: { backgroundColor: colors.background },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color="#DC2626" />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Pre-registraties" }}
      />
      <Stack.Screen
        name="create"
        options={{ title: "Lid Toevoegen" }}
      />
      <Stack.Screen
        name="[id]"
        options={{ title: "Details" }}
      />
    </Stack>
  );
}

